export enum RoutePaths {
    MainPage = '/shop',
    Sports = '/sports',
    Products = '/products',
    Brands = '/brands',
    Product = '/product',
    Cart = '/cart',
    Register = '/register',
    Login = '/login',
}
